<script>
import * as m from '@app/paraglide/messages.js';
import { showModal } from '@app/store/modalStore.svelte.js';
</script>

<li class="nav-item" title={m.toolbar_secondary_keyboard_shortcuts_title()}>
    <a
        class="nav-link"
        href="#!/"
        role="button"
        aria-label={m.toolbar_secondary_shortcut_keys_aria_label()}
        onclick={() => showModal('shortcutKeys')}
    ><i class="bi bi-keyboard"></i></a>
</li>
